import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import {
  getCurvatureStyleClickOrbisSD,
  getCurvatureStyleClickGenesis,
  getCurvatureStyleClickOrbisHD,
  getCurvatureStyleHoverOrbisSD,
  getCurvatureStyleHoverGenesis,
  getCurvatureStyleHoverOrbisHD,
} from "../style/curvature";

const isInteractive = (feature) => !feature.get("nonInteractive");

function getCurvatureInteractions(clickStyle, hoverStyle) {
  return function (layer, control) {
    const clickSelect = new Select({
      layers: [layer],
      condition: click,
      filter: isInteractive,
      style: function (feature, resolution) {
        return clickStyle(feature, resolution);
      },
    });
    clickSelect.on("select", function (e) {
      if (e.target.getFeatures().getLength() > 0) {
        control.set(
          "selectedFeatures",
          Array.from(e.target.getFeatures().getArray()),
        ); // create new array so that the event gets triggered
      } else {
        control.set("selectedFeatures", undefined);
      }
    });
    const hoverSelect = new Select({
      layers: [layer],
      condition: pointerMove,
      filter: isInteractive,
      style: function (feature, resolution) {
        return hoverStyle(feature, resolution);
      },
    });
    return [clickSelect, hoverSelect];
  };
}

export function getCurvatureInteractionsOrbisSD() {
  return getCurvatureInteractions(
    getCurvatureStyleClickOrbisSD,
    getCurvatureStyleHoverOrbisSD,
  );
}
export function getCurvatureInteractionsOrbisHD() {
  return getCurvatureInteractions(
    getCurvatureStyleClickOrbisHD,
    getCurvatureStyleHoverOrbisHD,
  );
}
export function getCurvatureInteractionsGenesis() {
  return getCurvatureInteractions(
    getCurvatureStyleClickGenesis,
    getCurvatureStyleHoverGenesis,
  );
}
